"use client";

import { FC } from "react";

interface BFLSkeletonProps {
  width?: number | string;
  height?: number;
  count?: number;
  classes?: string;
  borderRadius?: number;
}

const getSkeletonItems = (count: number) => Array.from({ length: Math.max(0, Math.ceil(count)) });

const BFLSkeleton: FC<BFLSkeletonProps> = ({
  width = "100%",
  height = 20,
  count = 1,
  classes = "",
  borderRadius,
}) => {
  return (
    <span aria-busy="true" aria-live="polite" data-testid="bfl-skeleton-wrapper">
      {getSkeletonItems(count).map((_, index) => (
        <span
          key={index}
          data-testid="bfl-skeleton"
          className={classes}
          style={{
            display: "block",
            width,
            height,
            borderRadius: borderRadius ?? 4,
            backgroundColor: "#E6E8EB",
            marginTop: index === 0 ? 0 : 8,
          }}
        />
      ))}
    </span>
  );
};

export default BFLSkeleton;
